import React, { lazy, Suspense } from 'react';

const LazyInvoiceDetail = lazy(() => import('./InvoiceDetail'));

const InvoiceDetail = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyInvoiceDetail {...props} />
  </Suspense>
);

export default InvoiceDetail;
